import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  id: "modal_confirm_import_user",
  ref: "modal_confirm_import_user",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_3 = { class: "modal-dialog modal-lg" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Nutzer bestätigen"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal"
  }, "×")
], -1)
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "wizard-form steps-basic wizard clearfix" }
const _hoisted_8 = { class: "steps steps-container" }
const _hoisted_9 = { role: "tablist" }
const _hoisted_10 = ["aria-disabled"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = {
  key: 0,
  class: "col-12"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("legend", { class: "font-weight-bold h6" }, "Daten zum Benutzer", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Hier sehen Sie die aktuellen Daten des importierten Benutzer aus ihrer Benutzer und Kontaktliste. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Diese können Sie jetzt bearbeiten. ")
], -1)
const _hoisted_16 = { class: "row mt-4" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "form-group row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-lg-2 col-form-label" }, "Vorname", -1)
const _hoisted_20 = { class: "col-12 col-lg-10" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Anrede wählen", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "Firma" }, "Firma", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "Herr" }, "Herr", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "Frau" }, "Frau", -1)
const _hoisted_25 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { class: "form-group row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-lg-2 col-form-label" }, "Firma", -1)
const _hoisted_29 = { class: "col-12 col-lg-10" }
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = { class: "form-group row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-lg-2 col-form-label" }, "Vorname", -1)
const _hoisted_33 = { class: "col-12 col-lg-10" }
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = { class: "form-group row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-lg-2 col-form-label" }, "Nachname", -1)
const _hoisted_37 = { class: "col-12 col-lg-10" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("hr", { class: "w-100" }, null, -1)
const _hoisted_39 = { class: "col-12" }
const _hoisted_40 = { class: "form-group row" }
const _hoisted_41 = { class: "col-lg-10" }
const _hoisted_42 = { class: "input-group" }
const _hoisted_43 = { class: "input-group-prepend" }
const _hoisted_44 = ["value"]
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "invalid-feedback" }
const _hoisted_47 = { class: "col-12" }
const _hoisted_48 = { class: "form-group row" }
const _hoisted_49 = { class: "col-lg-10" }
const _hoisted_50 = { class: "input-group" }
const _hoisted_51 = { class: "input-group-prepend" }
const _hoisted_52 = ["value"]
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "invalid-feedback" }
const _hoisted_55 = { class: "col-12" }
const _hoisted_56 = { class: "form-group row" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label" }, "Interventionsnummer", -1)
const _hoisted_58 = { class: "col-lg-10" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Keine Nummer ausgewählt", -1)
const _hoisted_60 = ["disabled"]
const _hoisted_61 = ["disabled"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("hr", { class: "w-100" }, null, -1)
const _hoisted_63 = { class: "col-12" }
const _hoisted_64 = { class: "form-group row" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-lg-2 col-form-label" }, "Email", -1)
const _hoisted_66 = { class: "col-12 col-lg-10" }
const _hoisted_67 = { class: "text-right w-100 mt-3" }
const _hoisted_68 = {
  key: 1,
  class: "col-12"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("legend", { class: "font-weight-bold h6" }, "Soll der Nutzer einen Zugang zum Portal erhalten ?", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", null, "Wenn Sie dem Nutze einen Zugang versenden , kann dieser sich im Portal einloggen und Aktionen vornehmen sowie Einstellungen sehen und ändern. Dies hängt von den vergebenen Rechten eines jeden Nutzer ab. ", -1)
const _hoisted_71 = { class: "custom-control custom-switch custom-control-dark mt-3" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "user_entry"
}, "Zugang erteilen ", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("legend", { class: "font-weight-bold h6" }, "Nutzerberechtigungen", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", null, " Wählen Sie alle Rechte aus, die der Nutzer im Portal bekommen soll ", -1)
const _hoisted_75 = { class: "table-responsive" }
const _hoisted_76 = { class: "table" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-100 font-weight-bold" }, "Recht"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Aktiv")
  ])
], -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("td", null, " Anlagen schalten ", -1)
const _hoisted_79 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "write_arming"
}, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("td", null, " Firmendaten / Ansprechpartner ändern ", -1)
const _hoisted_82 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "write_company"
}, null, -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("td", null, " Benutzer anzeigen ", -1)
const _hoisted_85 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "read_user"
}, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", null, " Benutzer anlegen / bearbeiten ", -1)
const _hoisted_88 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "write_user"
}, null, -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("td", null, " Rechnungen ", -1)
const _hoisted_91 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "write_invoice"
}, null, -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("td", null, " Verträge ", -1)
const _hoisted_94 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "write_contracts"
}, null, -1)
const _hoisted_96 = { class: "text-right w-100 mt-3" }
const _hoisted_97 = {
  key: 2,
  class: "col-12"
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("legend", { class: "font-weight-bold h6" }, "Projekte des Benutezr", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("p", null, " Hier sehen Sie in welchen Projekten der Nutzer Rechte besitzt. Sie können diese jetzt anpassen. ", -1)
const _hoisted_100 = { class: "table-responsive" }
const _hoisted_101 = { class: "table" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Firma"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Anschrift"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Berechtigung")
  ])
], -1)
const _hoisted_103 = { class: "d-none d-md-table-cell" }
const _hoisted_104 = { class: "d-none d-md-table-cell" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_106 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_107 = ["id", "onUpdate:modelValue"]
const _hoisted_108 = ["for"]
const _hoisted_109 = { class: "text-right w-100 mt-3" }
const _hoisted_110 = {
  key: 3,
  class: "col-12"
}
const _hoisted_111 = /*#__PURE__*/_createElementVNode("legend", { class: "font-weight-bold h6" }, "Abschluss", -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("p", null, " Dem Benutzer wird nun ein Link und ein Start Pin zugesendet. Sobald dieser den Link bestätigt und ein Passwort vergibt, ist der Nutzer verifiziert und kann sich einloggen. ", -1)
const _hoisted_113 = { class: "text-right w-100 mt-3" }
const _hoisted_114 = { class: "font-weight-bold mb-4" }
const _hoisted_115 = { class: "card" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "card-header header-elements-inline" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Verwalten Sie Ihre Benutzer")
], -1)
const _hoisted_117 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_118 = ["onClick"]
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3 d-flex flex-column align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn bg-transparent rounded-pill border-2 btn-icon ml-3 mr-3"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-user" })
  ])
], -1)
const _hoisted_120 = { class: "media-body" }
const _hoisted_121 = { class: "mr-3" }
const _hoisted_122 = { class: "mr-3" }
const _hoisted_123 = { class: "text-muted" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "btn btn-accent"
    }, "Nutzer bestätigen")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterBar = _resolveComponent("FilterBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, stepIndex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: stepIndex,
                      role: "tab",
                      class: _normalizeClass([{'current':stepIndex==_ctx.activeStep}, {'done':step.done&&stepIndex!=_ctx.activeStep, 'disabled':!step.done}]),
                      "aria-disabled": !step.done
                    }, [
                      _createElementVNode("a", {
                        href: "",
                        class: _normalizeClass({'disabled':!step.done}),
                        onClick: _withModifiers(($event: any) => (_ctx.go(stepIndex)), ["prevent"])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["number", step.icon])
                        }, _toDisplayString(step.icon ? null : stepIndex), 3),
                        _createTextVNode(" " + _toDisplayString(step.name), 1)
                      ], 10, _hoisted_11)
                    ], 10, _hoisted_10))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.activeStep === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, [
                            _withDirectives(_createElementVNode("select", {
                              name: "firstName",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.user.salutation.value) = $event))
                            }, _hoisted_25, 512), [
                              [_vModelSelect, _ctx.form.user.salutation.value]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("div", _hoisted_29, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              name: "firstName",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.user.company.value) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.form.user.company.value]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              name: "firstName",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.user.firstName.value) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.form.user.firstName.value]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              name: "firstName",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.user.lastName.value) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.form.user.lastName.value]
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_38,
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("label", {
                            class: _normalizeClass(["col-lg-2 col-form-label", {'text-danger':_ctx.form.user.tel.error}])
                          }, "Telefon", 2),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("span", _hoisted_43, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.user.areaCodeTel.value) = $event))
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phoneCodes, (code, cIndex) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: code,
                                      value: cIndex
                                    }, _toDisplayString(cIndex) + " ( " + _toDisplayString(code) + " )", 9, _hoisted_44))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.form.user.areaCodeTel.value]
                                ])
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                class: _normalizeClass(["form-control", {'is-invalid':_ctx.form.user.tel.error}]),
                                type: "text",
                                placeholder: "",
                                autocomplete: "off",
                                disabled: _ctx.form.user.tel.disabled,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.user.tel.value) = $event)),
                                onFocusout: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validatePhoneNumber('tel')))
                              }, null, 42, _hoisted_45), [
                                [_vModelText, _ctx.form.user.tel.value]
                              ]),
                              _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.form.user.tel.error), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("label", {
                            class: _normalizeClass(["col-lg-2 col-form-label", {'text-danger':_ctx.form.user.mobil.error}])
                          }, "Mobilnummer", 2),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("span", _hoisted_51, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.user.areaCodeMobil.value) = $event))
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phoneCodes, (code, cIndex) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: code,
                                      value: cIndex
                                    }, _toDisplayString(cIndex) + " ( " + _toDisplayString(code) + " )", 9, _hoisted_52))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.form.user.areaCodeMobil.value]
                                ])
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                class: _normalizeClass(["form-control", {'is-invalid':_ctx.form.user.mobil.error}]),
                                type: "text",
                                placeholder: "",
                                autocomplete: "off",
                                disabled: _ctx.form.user.mobil.disabled,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.user.mobil.value) = $event)),
                                onFocusout: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validatePhoneNumber('tel')))
                              }, null, 42, _hoisted_53), [
                                [_vModelText, _ctx.form.user.mobil.value]
                              ]),
                              _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.form.user.mobil.error), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _createElementVNode("div", _hoisted_58, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-control",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.user.interventionNumber.value) = $event))
                            }, [
                              _hoisted_59,
                              _createElementVNode("option", {
                                value: "mobil",
                                disabled: _ctx.form.user.mobil.value === '' || _ctx.form.user.mobil.error
                              }, " Handy: " + _toDisplayString(_ctx.form.user.mobil.value), 9, _hoisted_60),
                              _createElementVNode("option", {
                                value: "tel",
                                disabled: _ctx.form.user.tel.value === '' || _ctx.form.user.tel.error
                              }, " Festnetz: " + _toDisplayString(_ctx.form.user.tel.value), 9, _hoisted_61)
                            ], 512), [
                              [_vModelSelect, _ctx.form.user.interventionNumber.value]
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_62,
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("div", _hoisted_66, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              name: "firstName",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.user.email.value) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.form.user.email.value]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-default",
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeImportModal && _ctx.closeImportModal(...args)))
                      }, "Schließen"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-dark ml-3",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.go(2)))
                      }, "Weiter")
                    ])
                  ]))
                : (_ctx.activeStep === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _hoisted_69,
                      _hoisted_70,
                      _createElementVNode("div", _hoisted_71, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "user_entry",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.entry) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.entry]
                        ]),
                        _hoisted_72
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["mt-4", { 'd-none':!_ctx.form.entry }])
                      }, [
                        _hoisted_73,
                        _hoisted_74,
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("table", _hoisted_76, [
                            _hoisted_77,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_78,
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_79, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: "write_arming",
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.rights.arming.write) = $event))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.form.rights.arming.write]
                                    ]),
                                    _hoisted_80
                                  ])
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_81,
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_82, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: "write_company",
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.rights.company.write) = $event))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.form.rights.company.write]
                                    ]),
                                    _hoisted_83
                                  ])
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_84,
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_85, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: "read_user",
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.rights.user.read) = $event))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.form.rights.user.read]
                                    ]),
                                    _hoisted_86
                                  ])
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_87,
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_88, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: "write_user",
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.rights.user.write) = $event))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.form.rights.user.write]
                                    ]),
                                    _hoisted_89
                                  ])
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_90,
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_91, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: "write_invoice",
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.rights.invoice.write) = $event))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.form.rights.invoice.write]
                                    ]),
                                    _hoisted_92
                                  ])
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_93,
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_94, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: "write_contracts",
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.rights.contracts.write) = $event))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.form.rights.contracts.write]
                                    ]),
                                    _hoisted_95
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ], 2),
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-default",
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.go(1)))
                        }, "zurück"),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-dark ml-3",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.go(3)))
                        }, "Weiter")
                      ])
                    ]))
                  : (_ctx.activeStep === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                        _hoisted_98,
                        _hoisted_99,
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("table", _hoisted_101, [
                            _hoisted_102,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.rights.projects, (project, projectIndex) => {
                                return (_openBlock(), _createElementBlock("tr", { key: projectIndex }, [
                                  _createElementVNode("td", _hoisted_103, _toDisplayString(project.pid), 1),
                                  _createElementVNode("td", null, _toDisplayString(project.p_firma), 1),
                                  _createElementVNode("td", _hoisted_104, [
                                    _createTextVNode(_toDisplayString(project.p_strasse) + " " + _toDisplayString(project.p_hnr) + " ", 1),
                                    _hoisted_105,
                                    _createTextVNode(" " + _toDisplayString(project.p_plz) + " " + _toDisplayString(project.p_ort), 1)
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_106, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        class: "custom-control-input",
                                        id: 'custom-switch-'+projectIndex,
                                        "onUpdate:modelValue": ($event: any) => ((project.check) = $event)
                                      }, null, 8, _hoisted_107), [
                                        [_vModelCheckbox, project.check]
                                      ]),
                                      _createElementVNode("label", {
                                        class: "custom-control-label",
                                        for: 'custom-switch-'+projectIndex
                                      }, null, 8, _hoisted_108)
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_109, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-default",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.go(2)))
                          }, "zurück"),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-dark ml-3",
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.go(4)))
                          }, "Weiter")
                        ])
                      ]))
                    : (_ctx.activeStep === 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                          _hoisted_111,
                          _hoisted_112,
                          _createElementVNode("div", _hoisted_113, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-default",
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.go(3)))
                            }, "zurück"),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-primary ml-3",
                              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.confirmImport && _ctx.confirmImport(...args)))
                            }, "Abschließen")
                          ])
                        ]))
                      : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("h1", _hoisted_114, _toDisplayString(_ctx.headline), 1),
    _createVNode(_component_FilterBar, {
      filter: _ctx.filter,
      search: _ctx.search,
      onFilter: _ctx.onFilter
    }, null, 8, ["filter", "search", "onFilter"]),
    _createElementVNode("div", _hoisted_115, [
      _hoisted_116,
      _createElementVNode("ul", _hoisted_117, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: ""
          }, [
            _createElementVNode("a", {
              class: "media cursor-pointer align-items-center",
              onClick: ($event: any) => (_ctx.getEmpById(user.id))
            }, [
              _hoisted_119,
              _createElementVNode("div", _hoisted_120, [
                _createElementVNode("span", _hoisted_121, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1),
                _createElementVNode("span", _hoisted_122, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["icon-envelop", user.invitation == 1 ? 'text-primary' : 'text-secondary'])
                  }, null, 2),
                  _createElementVNode("i", {
                    class: _normalizeClass(["icon-user-check ml-2", user.verified == 1 ? 'text-primary' : 'text-secondary'])
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_123, _toDisplayString(user.email), 1)
              ]),
              _hoisted_124
            ], 8, _hoisted_118)
          ]))
        }), 128))
      ])
    ])
  ]))
}